module.exports = __webpack_public_path__ + "static/media/57pic.67d78a1f.jpg";